export enum StoreDeliveryCodeEnum {
	Delivery = 'DELIVERY',
	Pickup = 'PICK-UP',
}

export enum StoreStatusEnum {
	Open = 'open',
	Closed = 'closed',
}
